import { Col, Row, Button } from 'antd';
import React from 'react';
import CardChangePassword from '../Admin/CardChangePassword/CardChangePassword';
import style from './PublicChangePassword.module.scss'
import { useParams } from 'react-router-dom';
const PublicChangePassword: React.FC = () => {
    interface RouteParams {
        id: string
    }
    const params = useParams<RouteParams>();
    return (
        <div className={style["container"]}>
            <CardChangePassword typeCard= {"-admin"} terms={true} id={params.id} />
           
        </div>

    );
};


export default PublicChangePassword;